import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class NitriteSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.NitriteSensor,
    });
  }
}
